import { render, staticRenderFns } from "./labelName2.vue?vue&type=template&id=5344a69a&scoped=true&"
import script from "./labelName2.vue?vue&type=script&lang=js&"
export * from "./labelName2.vue?vue&type=script&lang=js&"
import style0 from "./labelName2.vue?vue&type=style&index=0&id=5344a69a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5344a69a",
  null
  
)

export default component.exports